import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  inject,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FichaDaObraService } from 'src/app/ficha-da-obra/service/ficha-da-obra.service';
import { environment } from 'src/environments/environment';
import { SucessoComponent } from '../../sucesso/sucesso.component';

@Component({
  selector: 'app-editar-tarefa',
  standalone: true,
  imports: [CommonModule, FormsModule, SucessoComponent],
  templateUrl: './editar-tarefa.component.html',
  styleUrls: ['./editar-tarefa.component.scss'],
})
export class EditarTarefaComponent implements OnInit {
  @Input() tarefa: any;
  @Output() close = new EventEmitter<void>();

  @Output() loading = new EventEmitter<boolean>();
  @Input() idObra: number | null = null;
  @Input() idModulo: number | null = null;
  @Output() tarefaEditada = new EventEmitter<any>();

  @Input() contatoInfo?: {
    cargo: string;
    nome: string;
    email: string;
    id?: number;
  };

  BASE_IMG_URL: string = environment.BASE_IMG_URL;
  sucesso = false;
  isLoadingObra: boolean = false; // Added loader property

  descricao: string = '';
  data: string = '';
  hora: string = '';
  responsibleID: string = '';
  actionID: string = '';
  responsavel: any[] = [];
  tarefas: any[] = [];
  contatos: any[] = [];
  isEdited: boolean = true;

  private _fichaDaObraService = inject(FichaDaObraService);

  constructor() {}

  ngOnInit() {
    this.descricao = this.tarefa?.descricao || '';
    this.data = this.tarefa?.data || '';
    this.hora = this.tarefa?.hora || '';
    this.responsibleID = this.tarefa?.raw?.responsibleID?.toString() || '';
    this.actionID = this.tarefa?.raw?.actionID?.toString() || '';

    if (this.tarefa?.contatoInfo) {
      this.contatoInfo = this.tarefa.contatoInfo;
    }

    this.popularResponsavelObra();
    this.popularAcao();
    this.listarContatosObra(this.tarefa?.raw?.contactID);
  }

  popularResponsavelObra(): void {
    this._fichaDaObraService.popularResponsavelObra().subscribe(
      (response) => {
        this.responsavel = response.data.sort((a, b) =>
          a.name.localeCompare(b.name),
        );
      },
      (error) => {
        console.error('Erro ao popular responsável:', error);
      },
    );
  }

  popularAcao(): void {
    this._fichaDaObraService.popularTarefaseAcoes().subscribe(
      (response) => {
        this.tarefas = response.data;
      },
      (error) => {
        console.error('Erro ao popular ações:', error);
      },
    );
  }

  editarTarefa(): void {
    this.loading.emit(true);
    if (!this.tarefa?.raw || !this.tarefa?.raw.workID || !this.tarefa?.raw.id) {
      console.error(
        'Erro: Propriedade raw ou IDs ausentes na tarefa:',
        this.tarefa?.raw,
      );
      return;
    }

    const body = {
      actionID: Number(this.actionID),
      followUp: this.formatFollowUp(this.data, this.hora),
      responsibleID: Number(this.responsibleID),
      description: this.descricao,
      workID: this.tarefa.raw.workID,
      contactID: this.contatoInfo?.id || null,
    };

    this._fichaDaObraService.editarTarefa(this.tarefa.raw.id, body).subscribe({
      next: () => {
        this.sucesso = true;
        this.tarefa.raw.source = 'editar-tarefa';
        this.tarefaEditada.emit(this.tarefa);
        this.loading.emit(false);
      },
      error: (err) => {
        console.error('Erro ao editar tarefa:', err);
        this.loading.emit(false);
      },
    });
  }

  criarTarefa() {
    this.loading.emit(true);
    if (!this.tarefa?.raw || !this.tarefa?.raw.workID || !this.tarefa?.raw.id) {
      console.error(
        'Erro: Propriedade raw ou IDs ausentes na tarefa:',
        this.tarefa,
      );
      return;
    }

    const body = {
      ActionID: Number(this.actionID),
      FollowUp: this.formatFollowUp(this.data, this.hora),
      ResponsibleID: Number(this.responsibleID),
      Description: this.descricao,
    };

    this._fichaDaObraService.novaTarefa(this.idObra, body).subscribe({
      next: () => {
        this.sucesso = true;
        this.tarefa.raw.source = 'criar-tarefa';
        this.tarefaEditada.emit();
        this.loading.emit(false);
      },
      error: (err) => {
        console.error('Erro ao criar tarefa:', err);
        this.loading.emit(false);
      },
    });
  }

  listarContatosObra(contactID?: number) {
    this.isLoadingObra = true;
    const subscription = this._fichaDaObraService
      .listarContatosObra(this.idObra!, this.idModulo!)
      .subscribe({
        next: (res) => {
          this.contatos = Array.isArray(res.data?.companies)
            ? res.data.companies
            : [];
          if (contactID) {
            let contatoEncontrado = null;
            for (const company of this.contatos) {
              contatoEncontrado = company.contacts?.find(
                (contato) => contato.contactId === contactID,
              );
              if (contatoEncontrado) {
                this.contatoInfo = {
                  cargo: contatoEncontrado.contactRole,
                  nome: contatoEncontrado.contactName,
                  email: contatoEncontrado.contactEmail,
                  id: contatoEncontrado.contactId,
                };

                break;
              }
            }
            if (!contatoEncontrado) {
              console.warn(
                'Contato não encontrado para o contactID:',
                contactID,
              );
            }
          }
          this.isLoadingObra = false;
        },
        error: (err) => {
          console.error('Erro ao listar contatos da obra:', err);
          this.isLoadingObra = false;
        },
      });
  }

  formatFollowUp(date: string, time: string): string {
    if (!date || !time) return '';
    const [yyyy, mm, dd] = date.split('-');
    let horaFormatada = time.length === 5 ? `${time}:00` : time;
    return `${dd}/${mm}/${yyyy} ${horaFormatada}`;
  }

  continuar() {
    this.sucesso = false;
    this.close.emit();
  }
}
